export default "__VITE_ASSET__69908a31__"